import { breakpoints, colors, fonts, pxToCssFont } from '@vfit/shared/themes';
import styled from 'styled-components';
import { IButtonCardStyle } from './buttonCard.models';

export const Container = styled.div<IButtonCardStyle>`
  display: flex;
  flex-direction: column;
  align-items: left;
  width: 100%;
  border-radius: 20px;
  padding: 32px 24px;
  gap: 32px;
  background: ${({ background }) =>
    background && background.isGradient
      ? `linear-gradient(${background.angle}deg, ${background.firstColor}, ${background.secondColor})`
      : background?.firstColor || colors.$ffffff};
  border: 1px solid
    ${({ background }) =>
      background && background.isGradient
        ? `linear-gradient(${background.angle}deg, ${background.firstColor}, ${background.secondColor})`
        : background?.firstColor || colors.$262626};

  @media (min-width: ${breakpoints.tablet}) {
    gap: 24px;
  }

  @media (min-width: ${breakpoints.desktop}) {
    padding: 32px 64px;
    gap: 24px;
  }
`;

export const TextDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Title = styled.h3<IButtonCardStyle>`
  margin: 0;
  font-family: ${fonts.exbold};
  font-weight: 800;
  ${pxToCssFont(28, 36)};
  color: ${({ textColor }) => textColor || colors.$262626};

  p {
    margin: 0;
  }

  @media (min-width: ${breakpoints.desktop}) {
    ${pxToCssFont(36, 48)};
  }
`;

export const Description = styled.div<IButtonCardStyle>`
  margin: 0;
  font-family: ${fonts.regular};
  font-weight: 400;
  ${pxToCssFont(20, 28)};
  color: ${({ textColor }) => textColor || colors.$262626};
  
  p {
    margin: 0;
  }

  @media (min-width: ${breakpoints.desktop}) {
    ${pxToCssFont(22, 32)};
  }
`;

